// ============================================================================
// note-client-mod -- useTheme Hook
//
// 主题管理 Hook，支持 light/dark/auto 模式。
// 自动检测系统偏好并持久化用户选择到 localStorage。
// ============================================================================
import * as React from 'react';
import { lightTheme, darkTheme } from './theme.js';
const STORAGE_KEY = 'hvsin-note-theme';
/** 获取初始主题模式 */
function getInitialMode() {
    if (typeof window === 'undefined')
        return 'light';
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored === 'light' || stored === 'dark' || stored === 'auto')
            return stored;
    }
    catch { /* ignore */ }
    return 'auto';
}
/** 根据模式解析实际主题 */
function resolveTheme(mode, systemDark) {
    if (mode === 'dark')
        return darkTheme;
    if (mode === 'light')
        return lightTheme;
    return systemDark ? darkTheme : lightTheme;
}
export function useTheme() {
    const [mode, setModeState] = React.useState(getInitialMode);
    const [systemDark, setSystemDark] = React.useState(() => {
        if (typeof window === 'undefined')
            return false;
        return window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false;
    });
    React.useEffect(() => {
        if (typeof window === 'undefined')
            return;
        const mq = window.matchMedia('(prefers-color-scheme: dark)');
        const handler = (e) => setSystemDark(e.matches);
        mq.addEventListener?.('change', handler);
        return () => mq.removeEventListener?.('change', handler);
    }, []);
    const theme = resolveTheme(mode, systemDark);
    const isDark = theme === darkTheme;
    const setMode = React.useCallback((newMode) => {
        setModeState(newMode);
        try {
            localStorage.setItem(STORAGE_KEY, newMode);
        }
        catch { /* ignore */ }
    }, []);
    const toggle = React.useCallback(() => {
        setMode(mode === 'dark' ? 'light' : 'dark');
    }, [mode, setMode]);
    return { theme, mode, isDark, setMode, toggle };
}
//# sourceMappingURL=use-theme.js.map